import * as React from 'react';

import { UIHeading1, UIHeading4 } from '@cian/ui-kit';

import * as styles from './styles.css';
import { IconActionInfo24 } from '@cian/ui-kit-design-tokens/icons';

interface IProfiDesktopLayoutProps extends React.PropsWithChildren {
  onClick: () => void;
}

export const ProfiDesktopLayout: React.FC<IProfiDesktopLayoutProps> = ({ onClick, children }) => {
  return (
    <section>
      <div className={styles['desktop-container']}>
        <div className={styles['desktop-image']} />

        <div>
          <UIHeading1 as="h2" color="text-primary-default">
            Подберем лучшего <br /> в своём деле
          </UIHeading1>

          <div className={styles['wrapper']}>{children}</div>

          <div className={styles['desktop-label']} onClick={onClick}>
            <IconActionInfo24 color="icon-positive-pressed"></IconActionInfo24>
            <UIHeading4 color="text-positive-default">Критерии качества наших агентов </UIHeading4>
          </div>
        </div>
      </div>
    </section>
  );
};
